<template>
  <div class="right_box_main">
    <div class="card-box">
      <!-- 右边卡片 -->
        <div class="card-4" style="width: 100%;">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="设备号:">
                  <el-input v-model="searchlist.deviceNumber" placeholder="请输入设备号" style="width:130px"></el-input>
                </el-form-item>
                <el-form-item label="在线状态:">
                  <el-select size="mini" v-model="searchlist.enable" placeholder="--状态--" style="width:130px" >
                    <el-option label="1" value="0">正常</el-option>
                    <el-option label="0" value="1">异常</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
                <el-form-item></el-form-item>
              </el-form>
            </div>
            <div class="three" style="margin-bottom:6px;">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="showDialog({},'add')">新增设备</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteRows">删除设备</el-button>
              <el-button type="primary" size="mini" @click="buFang">布防</el-button>
              <el-button type="danger" size="mini" @click="cheFang">撤防</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table :data="tableData" size="small" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" current-row-key highlight-current-row @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column align="center" prop="deviceNumber" label="设备号" width="120"></el-table-column>
				        <el-table-column align="center" prop="position" label="设备位置" width="200"></el-table-column>
                <el-table-column align="center" prop="enable" label="设备状态" width="100">
                  <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.enable == '0'" type="success">正常</el-tag>
                    <el-tag size="small" v-else type="danger">异常</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="duration" label="在线时间" width="100"></el-table-column>
                <el-table-column align="center" prop="gridPerson" label="网格员" width="120"></el-table-column>
				        <el-table-column align="center" prop="createDate" label="添加设备时间" width="180"></el-table-column>
                <el-table-column align="center" prop="monitorIndex" label="监控指标" width="160"></el-table-column>
                <el-table-column align="center" prop="isNewRecord" label="未处理异常" width="140">
                  <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.enable == '0'" type="info">0条</el-tag>
                    <el-tag size="small" v-else type="danger">115条</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="查看异常" placement="top-start">
                      <button class="tabBtn el-icon-warning-outline tabBtn-delete" @click="showDialog(scope.row,'error')"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="打开监控" placement="top-start">
                      <button class="tabBtn el-icon-video-camera tabBtn-audit" @click="showDialog(scope.row,'monitor')"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                      <button class="tabBtn el-icon-edit tabBtn-edit" @click="showDialog(scope.row,'edit')"></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :page-size="pageConfig.pageSize" layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange" :total="pageConfig.total" ></el-pagination>
            </div>
          </el-card>
        </div>
    </div>
    <!-- 弹出框编辑 -->
    <el-dialog :title="addDialog.title" :visible.sync="addDialog.off" width="720px" >
      <el-form label-position="right" size="mini" label-width="120px" :model="addDialog.form">
        <el-form-item label="设备号：" prop="deviceNumber">
          <el-input placeholder="请输入设备号" v-model="addDialog.form.deviceNumber"></el-input>
        </el-form-item>
        <el-form-item label="监控指标：">
          <el-select size="mini" v-model="addDialog.form.monitorIndex" placeholder="--监控指标--" style="width:100%" >
            <el-option label="火灾监控" value="火灾监控"></el-option>
            <el-option label="消防救援" value="消防救援"></el-option>
            <el-option label="防灾救灾" value="防灾救灾"></el-option>
            <el-option label="人员密集" value="人员密集"></el-option>
            <el-option label="其它" value="其它"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在区域：">
          <el-select v-model="addDialog.form.stree" placeholder="--选择街道--" 
            @change="getOrgs(addDialog.form.stree,'3')" style="width:174px">
            <el-option v-for="item in streetOptions" :key="item.id" 
              :label="item.orgName" :value="item.id"></el-option>
          </el-select>
          &nbsp;
          <el-select v-model="addDialog.form.community" placeholder="--选择社区--" 
            @change="getOrgs(addDialog.form.community,'4')" style="width:174px">
            <el-option v-for="item in communityOptions" :key="item.id" 
              :label="item.orgName" :value="item.id"></el-option>
          </el-select>
          &nbsp;
          <el-select v-model="addDialog.form.grid" placeholder="--选择网格--" style="width:174px">
            <el-option v-for="item in gridOptions" 
                  :key="item.id" :label="item.orgName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网格员：">
          <el-select v-model="addDialog.form.gridPerson" filterable remote reserve-keyword
            placeholder="请输入人员名称" :remote-method="remoteMethod" :loading="loading" style="width:100%">
            <el-option v-for="item in personOptions" :key="item.id"
              :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域：">
          <el-cascader ref="dialogArea" :options="dialogOptions" v-model="selectedOptions" 
            @change="handleChangeDialog" :placeholder="cascaderHolder" style="width:100%"></el-cascader>
        </el-form-item>
        <el-form-item label="设备位置：" prop="position">
          <el-input v-model="addDialog.form.position" @blur="transLocation"></el-input>
        </el-form-item>
        <el-form-item label="地图标识：" prop="lnglat">
          <div id="container" style="width:500px;height:240px;"></div>
        </el-form-item>
        <el-form-item label="监控时间：">
          <el-time-picker is-range v-model="timeArr" range-separator="至" value-format="HH:mm:ss"
            start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="是否启用：">
          <el-radio-group v-model="addDialog.form.enable">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" style="margin: 0 30px" @click="saveData">确定</el-button>
        <el-button type="info" size="small" @click="addDialog.off = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 弹出框查看监控 -->
    <el-dialog title="打开监控" :visible.sync="monitorDialog.off" width="600px" >
      <el-form label-position="right" size="mini" label-width="120px" :model="monitorDialog.form">
        <video v-if="monitorDialog.form.video !=''" :src="monitorDialog.form.video" style="width:560px;height:300px" controls="controls">您的浏览器不支持视频播放</video>
        <el-row :gutter="16" style="margin-top:10px;">
          <el-col :span="8">
            设备编号：{{monitorDialog.form.deviceNumber}}
          </el-col>
          <el-col :span="8">
            设备位置：{{monitorDialog.form.position}}
          </el-col>
          <el-col :span="8">
            等级：一般
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="monitorDialog.off = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 弹出框查看异常列表 -->
    <el-dialog title="查看异常" :visible.sync="errorDialog.off" width="1000px" >
      <el-table size="mini" :data="errorDialog.form.tableData" :header-cell-style="{ background: '#f8fafa' }"
        border align="center" current-row-key highlight-current-row>
        <el-table-column align="center" prop="level" label="等级" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.level == '1'" type="info">一般</el-tag>
            <el-tag size="mini" v-else-if="scope.row.level == '2'" type="warning">较重</el-tag>
            <el-tag size="mini" v-else-if="scope.row.level == '3'" type="warning">严重</el-tag>
            <el-tag size="mini" v-else type="danger">非常严重</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="source" label="案件来源" width="100"></el-table-column>
        <el-table-column align="center" prop="person" label="网格员" width="100"></el-table-column>
        <el-table-column align="center" prop="content" label="内容"></el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.status == '1'" type="success">已处理</el-tag>
            <el-tag size="mini" v-else type="danger">未处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="imgs" label="图片" width="200">
          <template slot-scope="scope">
            <el-image v-for="img in scope.row.imgs" :key="img"
                style="width:40px; height:40px;margin-left:3px;" :src="img" fit="contain"></el-image>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination :page-size="pageConfig.pageSize" layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange" :total="pageConfig.total" ></el-pagination> -->
      
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="errorDialog.off = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import { regionData, regionDataPlus } from 'element-china-area-data'
import AMap from "AMap"; // 引入高德地图
import {post} from "@/api/requrestHttp";
export default {
  data() {
    return {
      deviceType: '2',  //1-公共安全 2重点人脸布控 3-社区公共视频监控
      multipleSelection: [],
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      addDialog: {
        form: {},
        off: false,
        title: "",
        type: ""
      },
      monitorDialog: {
        form: {},
        off: false,
        title: "",
        type: ""
      },
      errorDialog: {
        form: {},
        off: false,
        title: "",
        type: ""
      },
      timeArr: ['00:00:00', '23:59:59'],
      map: null,
      dialogOptions: regionData,
      personOptions: [],
      loading: false,
      selectedOptions: [],
      cascaderHolder: '',
      streetOptions: [],
      communityOptions: [],
      gridOptions: [],
    };
  },
  methods: {
    //条件查询
    searchlistdata (){
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset (){
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange (val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas () {
      this.searchlist.deviceType = this.deviceType  //1-公共安全 2重点人脸布控 3-社区公共视频监控
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      let params = JSON.stringify(this.searchlist)
      console.log(params)
      var res = await request({
        url: "/admin/equipment/info/listEquipment",
        method: "POST",
        data: params
      })
      console.log(res)
      if (res.code == 200) {
        if(res.content != null){
          this.pageConfig.total = res.content.count;
          this.tableData = res.content.list
        }else{
          this.pageConfig.total = 0;
          this.tableData = []
        }
      }else{
        console.log(res)
        this.$message({
          message: "数据加载异常",
          type: "error"
        });
      }
    },
    async deleteRows() {
      if(this.multipleSelection.length != 1){
        this.$message({
          message: "请选择一条您要删除的数据项",
          type: "error"
        });
        return
      }
      this.$confirm("此操作将删除您选中的数据项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        // let ids = []
        // this.multipleSelection.forEach( item => {
        //   ids.push(item.id)
        // })
        let params = JSON.stringify({id:this.multipleSelection[0].id});
        console.log(params)
        var res = await request({
          url: "/admin/equipment/info/deleteEquipment",
          method: "POST",
          data: params
        });
        if (res.code == 200) {
          this.$message({
            message: '删除成功',
            type: "success"
          });
          this.pageConfig.pageNo = 1
          this.getPageDatas()
        }else{
          console.log(res)
          this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        })
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //新增
    async showDialog(row,flag) {
      this.getOrgs('0','2')
      this.addDialog.type = flag
      this.errorDialog.type = flag
      if(flag == 'add' ){
        this.addDialog.title = '新增设备'
        this.addDialog.off = true
        this.addDialog.form = {}
        this.errorDialog.off = false
      }else if(flag == 'edit'){
        this.addDialog.title = '修改设备'
        this.addDialog.off = true
        this.addDialog.form = {}

        let params = JSON.stringify({id:row.id})
        console.log(params)
        var res = await request({
          url: "/admin/equipment/info/getEquipment",
          method: "POST",
          data: params
        })
        console.log(res)
        if (res.code == 200) {
          this.addDialog.form = res.content
          if(res.content.timeSlotList.length > 0){
            this.timeArr = [res.content.timeSlotList[0].startTime,res.content.timeSlotList[0].endTime]
          }
          this.errorDialog.form = res.content
          this.monitorDialog.form = res.content
        }else{
          console.log(res)
          this.$message({
            message: "数据加载异常",
            type: "error"
          });
        }
      }else if(flag == 'monitor'){
        this.monitorDialog.title = '查看监控'
        this.monitorDialog.off = true
        this.monitorDialog.form = row
      }else{
        this.errorDialog.off = true
        this.errorDialog.form = row
        this.errorDialog.form.tableData = []
        console.log(row)
        let img = require("@/assets/images/community/tu1.png")
        let img1 = require("@/assets/images/community/tu2.png")
        let temp = {
            id:1,
            level:'1',
            source:'公共安全', 
            person: row.gridPerson, 
            content:'来自设备号'+row.deviceNumber+'监测到的异常情况：' + row.monitorIndex,
            imgs:[img,img1]
        }
        for(let i=1;i<10;i++){
          temp.id = i
          temp.level = i+''
          this.errorDialog.form.tableData.push(temp)
        }
        
      }

      if(flag == 'add' || flag == 'edit'){
        this.$nextTick(() => {
          this.initMap('container')
        });
      }
      
    },
    //获取组织机构信息
    async getOrgs(pId,orgLevel) {
      let params = JSON.stringify({parentId:pId, orgLevel: orgLevel, pageSize:50});
      // console.log(params)
      var res = await request({
        url: "/admin/org/info/findOrg",
        method: "POST",
        data: params
      })
      if (res.code == 200 && res.content != null) {
        if(orgLevel == '2'){
          this.streetOptions = res.content.list
        }else if(orgLevel == '3'){
          this.communityOptions = res.content.list
        }else if(orgLevel == '4'){
          this.gridOptions = res.content.list
        }
        
      }else{
        console.log(res)
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
     //新增/编辑框中，区域选择赋值
    handleChangeDialog (value) {
      var areas = this.$refs.dialogArea.getCheckedNodes()[0].pathLabels
      this.addDialog.form.province = areas[0]
      if(areas.length > 1){
        this.addDialog.form.city = areas[1]
      }
      if(areas.length > 2){
        this.addDialog.form.area = areas[2]
      }
    },
    //根据输入地址转换经纬度并标记
    transLocation() {
      var searchKey = this.addDialog.form.province+this.addDialog.form.city
          + this.addDialog.form.area+this.addDialog.form.position
      var map = new AMap.Map('container',{
          resizeEnable: true,
          zoom: 18,
        })
      var that = this
      AMap.plugin('AMap.Geocoder',function(){ 
        var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all"
        });
        var marker = new AMap.Marker();
        geocoder.getLocation(searchKey, function(status, result) {
          if (status === 'complete' && result.geocodes.length) {
              var lnglat = result.geocodes[0].location
              // console.log(lnglat)
              that.addDialog.form.longitude = lnglat.lng
              that.addDialog.form.latitude = lnglat.lat
              marker.setPosition(lnglat);
              map.add(marker);
              map.setFitView(marker);
          }else{
            that.$message({
              message: "获取坐标失败，请手动获取",
              type: "error"
            });
          }
        })
      })
    },
    //初始化地图插件的方法
    initMap(containerId) {
        var map = new AMap.Map(containerId,{
          resizeEnable: true,
          zoom: 18,
        })
        if(this.addDialog.form.longitude != undefined && this.addDialog.form.latitude != undefined){
          var marker = new AMap.Marker({
            position: [this.addDialog.form.longitude, this.addDialog.form.latitude],
            map: map
          });
          map.setFitView(marker);
        }else{
          AMap.plugin('AMap.Geolocation',function(){ //异步定位当前
              var geolocation = new AMap.Geolocation()
              map.addControl(geolocation)
          })
        }
        //定义地图坐标点击事件
        var that = this
        map.on('click', function(e) {
            that.addform.longitude = e.lnglat.getLng()
            that.addform.latitude = e.lnglat.getLat()
        })
    },
    
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        let params = JSON.stringify({name:query,pageNo:1,pageSize:30})
        // console.log(params);
        var res = await request({
            url: "/admin/user/info/list",
            method: "POST",
            data: params
        });
        // console.log(res);
        this.loading = false;
        if (res.code == 200) {
          if (res.content != null) {
            this.personOptions = res.content.list;
          } else {
            this.personOptions = [];
          }
        }
      } else {
        this.personOptions = [];
      }
    },
    async saveData() {
      this.addDialog.form.deviceType = this.deviceType
      this.addDialog.form.timeSlotList = [{startTime: this.timeArr[0], endTime:this.timeArr[1]}]
      let params = JSON.stringify(this.addDialog.form);
      console.log(params)
      let url = '/admin/equipment/info/updateEquipment'
      if(this.addDialog.type == 'add'){
        url = '/admin/equipment/info/insertEquipment'
      }
      var res = await request({
        url: url,
        method: "POST",
        data: params
      });
      if (res.code == 200) {
        this.$message({
          message: this.addDialog.title + '成功',
          type: "success"
        });
        this.addDialog.off = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      }else{
        console.log(res)
        this.$message({
            message: this.addDialog.title + "失败：" + res.message,
            type: "error"
          });
      }
      
    },
    buFang() {
      post("/facevision/info/startvisionData", {}).then(res => {

      })
    },
    cheFang() {
      post("/facevision/info/endtvisionData", {}).then(res => {

      })
    }
  },
  mounted() {
    this.getPageDatas()
  }
};
</script>